const Restore = () => {
  return <h1>Restore</h1>;
};

export default Restore;
